import { render } from "./FeatureComparisonModal.vue?vue&type=template&id=6643f1de&scoped=true"
import script from "./FeatureComparisonModal.vue?vue&type=script&lang=js"
export * from "./FeatureComparisonModal.vue?vue&type=script&lang=js"

import "./FeatureComparisonModal.vue?vue&type=style&index=0&id=6643f1de&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3529439572/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6643f1de"]])

export default __exports__